const HIDDEN_PAYLOAD_KEYS = new Set(["notificationId", "uploads", "meta"]);

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
    Boolean(value) && typeof value === "object" && !Array.isArray(value);

export const toEditableContent = (notification: unknown): Record<string, unknown> => {
    if (!isPlainObject(notification)) {
        return {};
    }

    return Object.fromEntries(
        Object.entries(notification).filter(([key, value]) => (
            !HIDDEN_PAYLOAD_KEYS.has(key) && value !== undefined
        )),
    );
};

export const stringifyEditableContent = (notification: unknown): string =>
    JSON.stringify(toEditableContent(notification), null, 2);

export const parseEditedContent = (
    raw: string,
): { ok: true; value: Record<string, unknown> } | { ok: false; error: string } => {
    try {
        const parsed = JSON.parse(raw) as unknown;
        if (!isPlainObject(parsed)) {
            return { ok: false, error: "JSON должен быть объектом" };
        }
        return { ok: true, value: parsed };
    } catch {
        return { ok: false, error: "Некорректный JSON" };
    }
};

export const buildEditPayload = (
    original: unknown,
    edited: Record<string, unknown>,
): Record<string, unknown> => {
    const source = isPlainObject(original) ? original : {};
    const payload: Record<string, unknown> = { ...edited };

    if (typeof source.notificationId === "string" && source.notificationId) {
        payload.notificationId = source.notificationId;
    }

    // uploads stay hidden in the editor json: media blocks reference them by
    // uploadKey, so they must be carried over to keep media blocks editable
    if (Array.isArray(source.uploads)) {
        payload.uploads = source.uploads;
    }

    return payload;
};
